import React from 'react';
import MigrationList from './MigrationList';
export default function MigrationDashboards() {
    return <MigrationList url={'dashboard'} keyLabel="label" />
};